import { render, staticRenderFns } from "./EmbeddedWhatsapp.vue?vue&type=template&id=b46f14b4"
import script from "./EmbeddedWhatsapp.vue?vue&type=script&lang=js"
export * from "./EmbeddedWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports